import {createSelector} from 'reselect'
import {USERS_WITHOUT_GROUP_ID} from 'constants'
import {createDefaultUserGroup} from '../util/groupUtils'
import {isTWSEnabled} from '../features/selectors'
import {FAKE_WORKFLOW_STATUSES} from '../workflowStatus/constants'
import {arrayToMap} from '../atUtils'

const getEntitiesState = state => state.entities

export const getUsers = state => getEntitiesState(state).users

export const getUser = (state, id) => getEntitiesState(state).users[id]

export const getTasks = state => getEntitiesState(state).tasks

export const getTask = (state, id) => getEntitiesState(state).tasks[id]

export const getProjects = state => getEntitiesState(state).projects

export const getProject = (state, id) => getEntitiesState(state).projects[id]

export const getCustomers = state => getEntitiesState(state).customers

export const getCustomer = (state, id) => getEntitiesState(state).customers[id]

export const getTypesOfWork = state => getEntitiesState(state).typesOfWork

export const getTypeOfWork = (state, id) => getEntitiesState(state).typesOfWork[id]

const getWorkflowStatusesRegardlessTWSFeature = state => getEntitiesState(state).workflowStatuses

export const getWorkflowStatuses = createSelector(
    isTWSEnabled,
    getWorkflowStatusesRegardlessTWSFeature,
    (twsEnabled, statuses) => twsEnabled ? statuses : arrayToMap(FAKE_WORKFLOW_STATUSES)
)

export const getWorkflowStatusesArray = createSelector(
    getWorkflowStatuses,
    (statusesMap) => {
        return Object.values(statusesMap)
    }
)

export const getWorkflowStatus = (state, id) => getEntitiesState(state).workflowStatuses[id]

export const getUserGroups = (state) => getEntitiesState(state).userGroups

export const getUserGroupsWithDefault = createSelector(
    getUserGroups,
    (userGroups) => {
        return {
            [USERS_WITHOUT_GROUP_ID]: createDefaultUserGroup(),
            ...userGroups
        }
    }
)

export const getTimeZoneGroups = (state) => getEntitiesState(state).timeZoneGroups



// WEBPACK FOOTER //
// ./web/js/entities/selectors.js